const isTextMatchingSearchQuery = (searchQuery, text) => {
  const normalizedSearchQuery = searchQuery.trim().toLowerCase();

  return !!normalizedSearchQuery && text.toLowerCase().includes(normalizedSearchQuery);
};

export default isTextMatchingSearchQuery;
